/* eslint-disable @typescript-eslint/no-unused-vars */
import  { createContext, useState, useContext } from 'react';
import { PRE_APPROVED_PRODUCTS_NAME } from 'constants/constants';

export const ProductContext = createContext({
    productDataFillOutFlow: [],

    setProductDataFillOutFlow: (productDataFillOutFlow) => {},
    allowedBanks: [],

    setAllowedBanks: (allowedBanks) => {},
    requiredDocumentation: [],

    setRequiredDocumentation: (requiredDocumentation) => {},
    productBizId: '',

    setProductBizId: (productBizId) => {},
    isPreApproved: false,
    currentScreen: '',

    setCurrentScreen: (currentScrren) => {},
    maxNumberOfInstallments: 24,

    setMaxNumberOfInstallments: (maxNumberOfInstallments) => {},
    minNumberOfInstallments: 3,

    setMinNumberOfInstallments: (minNumberOfInstallments) => {}
});

const { Provider, Consumer } = ProductContext;

export const ProductProvider = ({ children }) => {
    const [productDataFillOutFlow, setProductDataFillOutFlow] = useState([]);
    const [allowedBanks, setAllowedBanks] = useState();
    const [requiredDocumentation, setRequiredDocumentation] = useState([]);
    const [productBizId, setProductBizId] = useState('');
    const [isPreApproved, setIsPreApproved] = useState(false);
    const [currentScreen, setCurrentScreen] = useState();
    const [maxNumberOfInstallments, setMaxNumberOfInstallments] = useState();
    const [minNumberOfInstallments, setMinNumberOfInstallments] = useState();

    return (
        <Provider value={
            {
                productDataFillOutFlow,
                setProductDataFillOutFlow,
                allowedBanks,
                setAllowedBanks,
                requiredDocumentation,
                setRequiredDocumentation,
                productBizId,
                setProductBizId: (value) => {
                    setProductBizId(value);
                    setIsPreApproved(PRE_APPROVED_PRODUCTS_NAME.includes(value));
                },
                isPreApproved,
                maxNumberOfInstallments,
                setMaxNumberOfInstallments,
                currentScreen,
                setCurrentScreen,
                minNumberOfInstallments,
                setMinNumberOfInstallments
            }}>
            {children}
        </Provider>
    );
};

const useProduct = () => useContext(ProductContext);

export { useProduct };

export const ProductConsumer = Consumer;
